import React, {useEffect, useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'

interface Props {
  action: any
  changeStatusMessage: any
  isOpen: {[key: number]: boolean}
  setIsOpen: React.Dispatch<React.SetStateAction<{[key: number]: boolean}>>
}

const ViewMessageAction: React.FC<Props> = ({action, changeStatusMessage, isOpen, setIsOpen}) => {
  // Faire uniquement le traitement pour les messages clients
  const messages = action.type.code !== 'MESS CLIENT'
    ? [{date: action.dateEcheance, message: action.commentaire}]
    : action.commentaire
      ?.split('###')
      .map((msg) => {
        const trimmed = msg.trim()
        if (!trimmed) return null

        const parts = trimmed.split(' ')
        const date = parts.slice(0, 2).join(' ')
        const message = parts.slice(2).join(' ').trim()
        return {date, message}
      })
      .filter(Boolean) || []

  return (
    <>
      {action.id && isOpen[action.id] && (
        <div className=''>
          {messages.length > 0 ? (
            <div
              className='card-body px-4 overflow-auto py-2 align-items-start'
              style={{maxHeight: '200px', textAlign: 'left'}}
            >
              {messages.map((item, index) => (
                <div key={index} className='bg-light rounded px-3 py-2 mb-2'>
                  <div className='text-muted mb-1 text-end' style={{fontSize: '0.75rem'}}>
                    {item?.date}
                  </div>
                  <div style={{whiteSpace: 'pre-line'}}>
                    {item?.message.replace(/\n{3,}/g, '\n\n')}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className='text-muted text-center p-3'>Aucun message pour le moment.</div>
          )}
        </div>
      )}
    </>
  )
}

export default ViewMessageAction
